import React from 'react'
import { Container } from 'react-bootstrap';
import hsrd from '../assets/hsrd.png';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header>
        <Container>
            <img src={hsrd} alt='Hull Sunday Run Day' />
            <div className='lang'>
                <Link to={ '/' }>FR</Link> | <Link to={ '/en' }>EN</Link>
            </div>
        </Container>
    </header>
  )
}

export default Header